(function () {
  const words = {
    en: 'own',
    fr: 'PROPRES'
  };

  function getLanguage() {
    // Shopify usually provides the language in the URL.
    // Example: /fr/collections/... 
    const path = window.location.pathname;
    const match = path.match(/^\/([a-z]{2})(?:\/|$)/i);

    if (match && words[match[1].toLowerCase()]) {
      return match[1].toLowerCase();
    }

    // Fallback to <html lang="">
    const htmlLang = document.documentElement.lang
      ?.toLowerCase()
      .split('-')[0];

    return htmlLang || 'en';
  }

  function wrapWord() {
    const div = document.querySelector('.collection__dynamic-part');

    if (!div) return;

    const lang = getLanguage();
    const targetWord = words[lang];

    if (!targetWord) return;

    const walker = document.createTreeWalker(
      div,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(node => {
      // Don't process text that is already inside our span
      if (node.parentElement?.classList.contains('localized-word')) {
        return;
      }

      const text = node.nodeValue;

      const regex = new RegExp(
        `\\b(${targetWord.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})\\b`,
        'gi'
      );

      if (!regex.test(text)) return;

      regex.lastIndex = 0;

      const fragment = document.createDocumentFragment();

      let lastIndex = 0;
      let match;

      while ((match = regex.exec(text)) !== null) {
        // Text before the word
        fragment.appendChild(
          document.createTextNode(
            text.substring(lastIndex, match.index)
          )
        );

        // Wrapped word
        const span = document.createElement('span');
        span.className = 'localized-word';
        span.textContent = match[0];

        fragment.appendChild(span);

        lastIndex = regex.lastIndex;
      }

      // Remaining text
      fragment.appendChild(
        document.createTextNode(text.substring(lastIndex))
      );

      node.parentNode.replaceChild(fragment, node);
    });
  }

  // Run initially
  wrapWord();

  // Shopify/apps may update the collection dynamically
  const observer = new MutationObserver(() => {
    wrapWord();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
